import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { RolesService } from 'src/app/services/service.index';

declare var toastr;

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styles: []
})
export class RolesComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceR: any[];
  dataResourceV: any[];
  dataResourceVAsignadas: any[];
  model: any = {
    id: 0,
    vista_id: 0,
    rol_id:0,
    posicion:'',
    uri:'',
    icono:'',
    estado:'',
    descripcion: '',
    activo:false
  };
  rol: string ='';
  idRol: number;  
  idVistaAsigado: number = 0;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleAddVista: boolean = false;
  state_toogle: boolean = false;  
  baseUrl = environment.apiEndpoint;
  hasError: any;
  estado: any;

  constructor(private _rs: RolesService) {
    this.clearErrors();
    this.getRoles();
    this.estado = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { vista_id: false };
  }

  getRoles() {
    this._rs.getRoles().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceR = result.data;
        } else {
          this.dataResourceR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.descripcion = '';
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.descripcion = data.descripcion;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  saveRol() {
    this.hasError = { descripcion: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {        
        this._rs.postRol(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getRoles();
              this.popupVisibleAdd = false;
              toastr.success('Rol adicionado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {        
        this._rs.putRol(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getRoles();
              this.popupVisibleAdd = false;
              toastr.success('Rol actualizado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.idRol = id;
    this.popupVisibleDel = true;
  }

  deleteRol() {
    this._rs.deleteRol(this.idRol).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getRoles();
          this.popupVisibleDel = false;
          toastr.success('Eliminado correctamente.');
        } else {
          this.getRoles();
          this.popupVisibleDel = false;
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }

  showModalAddVista(data: any) {   
    this.dataResourceVAsignadas = []; 
    this.getVistas();
    this.getVistasAsignados(data.id);
    this.model.rol_id = data.id;    
    this.rol = data.descripcion;    
    this.popupVisibleAddVista = true;

  }

  getVistas(){
    this._rs.getVistas().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceV = result.data;          
        } else {
          this.dataResourceV = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getDisplayVistas(item) {
    if (!item) {
      return '';
    }

    return `${item.modulo}:  ${item.descripcion} - ${item.uri}`;
  }

  getVistasAsignados(id: number) {    
    this._rs.getVistasAsignadas(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceVAsignadas = result.data;          
        } else {
          this.dataResourceVAsignadas = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalDeleteVista(id: number) {    
    this.idVistaAsigado = id;
    this.popupVisibleDel = true;
  }

  deleteVista() {
    this._rs.deleteVistaAsignado(this.idVistaAsigado).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getVistasAsignados(this.model.rol_id);
          this.popupVisibleDel = false;
          toastr.success('Eliminado correctamente.');
        }
      },
      error => { console.log('Error', error); });
  }

  saveVistaRol() {    
    if (this.validateVistaAsignado(this.model)) {
      if (this.model.id == 0) {
        this._rs.postVistaAsignado(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getVistasAsignados(this.model.rol_id);              
              toastr.success('Vista asignado correctamente.');
            } else if (result.status == 201) {
              toastr.warning(result.data);
            } else {
              toastr.warning(result.data);
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  validateVistaAsignado(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.vista_id, 'integer')) {
      this.hasError.vista_id = true; res = false;
    }   
    
    return res;
  }


}
